<template>
  <b-container class="contendordepagina">
    <loading :active.sync="isEnviando" :is-full-page="true"></loading>
    <AlertaError v-if="mensajeerror.length" :mensajeerror="mensajeerror" v-on:cerrado="onAlertErrorCerrado"></AlertaError>

    <div v-if="paso == 1">
      <SubirPDFaFirmar tituloh1="Paso 1 de 4. Sube el PDF del documento que se va a enviar a firmar por via electrónica" :seleccionartipologia="true" :descripcion="descripcion" :indicardescripcion="true" seccionactiva="SFY" v-on:paso-atras="onPasoAtras" v-on:pdf-subido="onPDFSubido"> </SubirPDFaFirmar>
    </div>
    <div v-if="paso == 2">
      <DefinicionCaracteristicasDeFirmantes tituloh1="Paso 2 de 4. Características de la firma" :firmantes="datosdocumento.firmantes" :pdfdoc="pdfdocumento" :ubicacionfirmas="ubicacionfirmas" v-on:paso-atras="onPasoAtras" v-on:atributos-firmantes-definidos="onAtributosFirmatesDefinidos"> </DefinicionCaracteristicasDeFirmantes>
    </div>
    <div v-if="paso == 3">
      <!-- <AccionPosteriorAlEnvio
          tituloh1 = "Paso 3 de 4. Automatiza la acción posterior a la firma"
          :datosexpediente="datosdocumento"
          v-on:paso-atras="onPasoAtras"
          v-on:accion-definida="onAccionDefinida"></AccionPosteriorAlEnvio>
    </div>
    <div v-if="paso==5"> -->
      <ConfirmacionDelEnvio tituloh1="Paso 3 de 4. Confirmación del envío" :datosdocumento="datosdocumento" v-on:paso-atras="onPasoAtras" v-on:envio-confirmado="onEnvioConfirmado"></ConfirmacionDelEnvio>
    </div>
    <div v-if="paso == 4">
      <!-- <FirmarEnLinea
          tituloh1 = "Paso 4 de 4. Firma el documento"
          :urlfirmaenlinea="urlfirmaenlinea"
          v-on:paso-atras="onPasoAtras"
          src="https://app.sandbox.signaturit.com/document/c8fecf6a-e4a5-475d-b500-74d373dbf5fc/6aeaf41a-f3dc-4faa-83e5-f23972bb66f5"
          "https://app.sandbox.signaturit.com/document/3e7358b0-9e08-4944-9da9-26d7bdf478b0/09994967-0bd3-40b3-b6d7-6895adce59a4"
          v-on:envio-confirmado="onEnvioConfirmado"></FirmarEnLinea> -->
      <div class="m-auto w-50 p-2">
        <!-- <iframe :src="resultadoefirma.datosrecibidos.url" class="border rounded" style="height: 320px; width: 240px" /> -->
        <h1>Paso 4 de 4. Firma el documento</h1>
        <div class="my-3">
          <div v-if="cargandoiframefirmadirecta">Cargando página de Signaturit...</div>
          <div v-else>
            <b-embed class="border rounded" type="iframe" aspect="1by1" :src="resultadoefirma.datosrecibidos.url"></b-embed>
            <p>
              ¿Tienes problemas para cargar la página de firma? Clica
              <a :href="resultadoefirma.datosrecibidos.url" target="_blank">aquí</a>
              para abrirla en una nueva página
            </p>
            <p>
              Si has completado la firma y no se ha actualizado la página de forma automática, clica
              <a href="#" @click.prevent="paso++">aquí</a> para continuar.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="paso == 5">
      <ResultadoDelEnvio :datosdocumento="datosdocumento" :resultadoefirma="resultadoefirma"></ResultadoDelEnvio>
    </div>
  </b-container>
</template>

<script>
import AlertaError from '@/components/AlertaError.vue';
import SubirPDFaFirmar from '@/components/SubirPDFaFirmar.vue';
import DefinicionCaracteristicasDeFirmantes from '@/components/DefinicionCaracteristicasDeFirmantes.vue';
import ConfirmacionDelEnvio from '@/components/ConfirmacionDelEnvio.vue';
import ResultadoDelEnvio from '@/components/ResultadoDelEnvio.vue';
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';

export default {
  components: {
    AlertaError,
    SubirPDFaFirmar,
    DefinicionCaracteristicasDeFirmantes,
    ConfirmacionDelEnvio,
    ResultadoDelEnvio,
    Loading
  },
  data() {
    return {
      mensajeerror: '',
      paso: 0,
      datosdocumento: null,
      pdfdocumento: '',
      ubicacionfirmas: '',
      envioconfirmado: false,
      isEnviando: false,
      descripcion: '',
      resultadoefirma: null,
      cargandoiframefirmadirecta: true
    };
  },
  mounted() {
    this.$store.commit('SET_SECCION', 'Envío de un documento a firmar por mí');
    this.paso = 0;
    this.inicializar();
  },
  methods: {
    inicializar: function () {
      const firmantes = [
        {
          nombre: this.usuario_nombre,
          email: this.usuario_email,
          cargo: '',
          empresa: 'MANUSA',
          modofirma: 'manuscrita',
          selloempresa: 'sinsello',
          esexterno: false
        }
      ];
      console.log('firmantes - init', firmantes);
      this.activarefirma(firmantes);
    },
    activarefirma: function (firmantes) {
      // Los firmantes los damos por ya definidos
      const params = {
        firmantes: firmantes,
        descripcion: this.descripcion,
        validadopor: this.usuario_email,
        accion: 'activar-efirma-estandar'
      };

      this.isEnviando = true;
      // Se envía el email personalizado mediante API con un método específico, que genera dos PDF: hoja de validación y borrador contrato
      var _t = this;
      this.axios
        .post('efirma/accion', params, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.usuario_token}`
          }
        })
        .then(function (response) {
          if (response.data.error === '') {
            console.log('activar-efirma-estandar', response.data.datosdocumento);
            _t.datosdocumento = response.data.datosdocumento;
            _t.datosdocumento.firmantes.forEach((f) => {
              f.piefirma.activado = false;
              f.posicionfirma.definida = false;
              f.efirmadefinida = false;
            });
            _t.paso++;
          } else {
            _t.mensajeerror = 'ERROR: ' + response.data.error;
          }
        })
        .catch(function (error) {
          console.log('activar-efirma-estandar - error', error);
          _t.mensajeerror = 'Error 1020. No se pudo iniciar el proceso.<br />' + error;
        })
        .then(function () {
          _t.isEnviando = false;
        });
    },
    //Ejemplo de uso: console.log("Certificado De MDS", this.certificadosegunmodoysello("cdsegunsello", "selloMDS"))
    certificadosegunmodoysello: function (modofirma, selloempresa) {
      if (modofirma === 'cdsegunsello') {
        const mcde = this.$store.getters.misCertificadosDeEmpresa.filter((c) => c.sello === selloempresa)[0];
        return mcde.certificado;
      }
      return '';
    },
    onAlertErrorCerrado: function () {
      this.mensajeerror = '';
    },
    onPasoAtras: function () {
      switch (this.paso) {
        case 2:
          this.pdfdocumento = null;
          break;
      }
      this.paso--;
      if (this.paso === 0) document.location.href = '/gestion-documentos-listado/?token=' + this.$store.getters.tokenusuario;
    },
    /**
     * @description Proviene de SubirPDFaFirmar.
     *    Devuelve el contenido (base64) del PDF que se enviará a firmar, con el fin de disponer de él para poderlo visualizar
     */
    onPDFSubido: function (contenidopdf, tipologia, descripcion) {
      //console.log("pdfsubido", pdfsubido)
      this.pdfdocumento = contenidopdf;
      this.datosdocumento.tipologia = tipologia;
      this.datosdocumento.descripcion = descripcion;
      this.paso++;
    },
    /**
     * @description Proviene de DefinicionCaracteristicasDeFirmantes.
     *    Devuelve, de cada firmante, la definición final de los atributos de cada firma
     */
    onAtributosFirmatesDefinidos: function (ubicacionfirmas, atributosfirmantes) {
      this.datosdocumento.ubicacionfirmas = ubicacionfirmas;
      this.datosdocumento.firmantes = atributosfirmantes;
      console.log('onAtributosFirmatesDefinidos', this.datosdocumento);
      this.paso++;
    },
    /**
     * @description Proviene de ConfirmacionDelEnvio.
     *    Devuelve el cuerpo del mensaje que se enviará al firmante de Manusa
     */
    onEnvioConfirmado: function () {
      this.envioconfirmado = true;

      console.log('onEnvioConfirmado', this.datosdocumento);
      var _t = this;
      const params = {
        datapdf: this.pdfdocumento,
        atributosfirmantes: this.datosdocumento.firmantes,
        modoborrador: false,
        accion: 'procesar-pdf-segun-firmantes-' + this.datosdocumento.ubicacionfirmas
      };
      console.log('onEnvioConfirmado', params);
      this.axios
        .post('/efirma/accion', params, {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_CLAVEAPIEFIRMA}`
          }
        })
        .then(function (response) {
          _t.iniciarProcesoDeFirma(response.data.srcpdfprocesado);
        });
    },
    /**
     * @description Envía la orden a la API para dar inicio al proceso de efirma del contrato, compuesta por:
     *              - Envío de orden de firma electrónica a Signaturit del contrato procesado
     *              Una vez finalizado, se muestra el resultado de la operación (en el siguiente paso)
     */
    iniciarProcesoDeFirma: function (pdfparafirmar) {
      var firmantes = [];
      var cuerpodelcorreo = "Se solicita tu firma en el documento '" + this.datosdocumento.descripcion + "').\nPara llevar a cabo la firma electrónica del mismo, se ruega se sigan las instrucciones indicadas.\nAtentamente,\n";

      this.datosdocumento.firmantes.forEach((f) => {
        firmantes.push({
          id: f.id,
          mensajeprivado: '',
          nombre: f.nombre,
          email: f.email,
          modofirma: f.modofirma,
          digital_certificate_name: this.certificadosegunmodoysello(f.modofirma, f.selloempresa)
        });
      });
      const params = {
        nombrefichero: this.datosdocumento.codigo + '.pdf',
        datapdf: pdfparafirmar,
        delivery_type: 'url',
        remitente: {
          nombre: this.usuario_nombre,
          email: this.usuario_email
        },
        cc: [
          {
            nombre: this.usuario_nombre,
            email: this.usuario_email
          }
        ],
        numerofirmantes: firmantes.length,
        firmantes: firmantes,
        emailfirmantes: {
          asunto: 'Firma de documento',
          cuerpo: cuerpodelcorreo
        },
        signing_mode: 'parallel',
        data: {
          titulo: this.datosdocumento.descripcion,
          tipologia_codigo: this.datosdocumento.tipologia,
          tipologia_descripcion: this.$store.getters.misTipologiasDeEFirma.filter((c) => c.codigo === this.datosdocumento.tipologia)[0].descripcion,
          departamento: this.$store.getters.misTipologiasDeEFirma.filter((c) => c.codigo === this.datosdocumento.tipologia)[0].departamento
        },
        modoapp: this.$store.getters.miModoApp,
        accion: 'enviar-documento-a-firmar'
      };
      console.log(params);
      this.isEnviando = true;
      // Se envía el email personalizado mediante API con un método específico, que genera dos PDF: hoja de validación y borrador contrato
      var _t = this;
      this.axios
        .post('/efirma/accion', params, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.usuario_token}`
          }
        })
        .then(function (response) {
          console.log('enviar-documento-a-firmar', response);
          if (response.data.error === '') {
            // se da por concluido el envío y se informa del resultado
            _t.datosdocumento.procesoefirma = {
              enviadaaefirmantes: true,
              estadoefirma: 'PENDIENTE'
            };
            _t.resultadoefirma = response.data.signaturit;
            _t.paso++;
            setTimeout(function () {
              _t.cargandoiframefirmadirecta = false;
            }, 5000);
          } else {
            _t.mensajeerror = 'ERROR: ' + response.data.error;
          }
        })
        .catch(function (error) {
          console.log('enviar-documento-a-firmar - error', error);
          _t.mensajeerror = 'Error 1002. No se pudo enviar el documento a firmar por Signaturit.<br />' + error;
        })
        .then(function () {
          _t.isEnviando = false;
        });
    },
    created: function () {
      var _t = this;
      window.addEventListener('message', function (e) {
        // e.data.event       = EVENT_TYPE
        // e.data.documentId  = DOCUMENT_ID
        // e.data.signatureId = SIGNATURE_ID

        if (e.data.event === 'completed') {
          _t.paso++;
        }
      });
    },
    destroyed: function () {
      window.removeEventListener('message');
    }
  },
  watch: {},
  computed: {
    ...mapState(['user']),
    usuario_nombre: {
      get() {
        if (!this.user) return '';
        console.log('get', this.user);
        return this.user.nombre;
      }
    },
    usuario_token: {
      get() {
        if (!this.user) return '';
        return this.user.token;
      }
    },
    usuario_email: {
      get() {
        if (!this.user) return '';
        return this.user.email;
      }
    }
  }
};
</script>

<style scoped></style>
